
import { Options, mixins } from "vue-class-component";
import { ref } from "vue";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";


interface IReport {
    productName: string;
    packSize: string;
    stripSize: string;
    batchNo: string;
    qty: string;
    expiryDate: string;
    minStock: string;
    branchName: string;
    supplierName: string;
    contactNo: string;
}

@Options({
    title: 'Stock Expiry Report',
    components: {},
})
export default class StockExpiryReport extends mixins(UtilityOptions) {
    private dt = ref();
    private lists: IReport[] = [];
    private reportService;
    private resultTitle = "";
    private productDialog = false;
    private loading = false;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [
        { label: "Reports", to: "index" },
        { label: "Stock Expiry Report", to: "expiry-report" },
    ];

    private searchFilters = {
        id: "",
        date1: "",
        date2: "",
        filterType: "None",
        storeType: "all_stores",
        storeID: 0,
    };

    private dialogTitle;
    private submitted = false;
    private filterBranch;
    private filterDates = [];

    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.reportService = new StoreReports();
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        this.storeList();
        this.loadList();
    }

    //OPEN DIALOG TO ADD NEW ITEM
    openDialog() {
        this.submitted = false;
        this.dialogTitle = "Filter Report";
        this.productDialog = true;
    }

    storeList() {
        this.reportService.getFilterList().then((res) => {
            this.filterBranch = res.branches;
            this.filterBranch.push({id:0, name:'All'}); 
            this.filterDates   = res.datesList;
        });
    }

    // USED TO GET SEARCHED ASSOCIATE
    loadList() {
        //console.log("load list of stock expiry");
        this.loading = true;
        this.reportService.stockExpiryReport().then((res) => {
            //const data = this.camelizeKeys(res);
            this.resultTitle = res.resultTitle;
            this.lists = res.record;
            //console.log("load list of stock expiry >> ",res);
            this.loading = false;
        });
        this.productDialog = false;
    }

    get rList() {
        const l: IReport[] = [];

        this.lists.forEach((e) => {
            e.expiryDate = this.formatMonthDate(e.expiryDate);
            l.push(e);
        });

        return l;
    }

    clearForFilters() {
        this.searchFilters.date1 = "";
        this.searchFilters.date2 = "";
    }

    clearSearch() {
        this.searchFilters.filterType = "None";
    }
}
